import React, { createContext, useContext, useState } from 'react';

export const SharedDataContext = createContext();

export const SharedDataProvider = ({ children }) => {
    const [newCustomer, setNewCustomer] = useState(null);
    const [newTerminal, setNewTerminal] = useState(null);
    const [newPaymentLink, setNewPaymentLink] = useState(null);
    const [newInvoice, setNewInvoice] = useState(null);
    const [newPaymentRequest, setNewPaymentRequest] = useState(null);

    return (
        <SharedDataContext.Provider
            value={{
                newCustomer,
                setNewCustomer,
                newTerminal,
                setNewTerminal,
                newPaymentLink,
                setNewPaymentLink,
                newInvoice,
                setNewInvoice,
                newPaymentRequest,
                setNewPaymentRequest
            }}
        >
            {children}
        </SharedDataContext.Provider>
    );
};

export const useSharedData = () => {
    const context = useContext(SharedDataContext);
    if (!context) {
        throw new Error('useSharedData must be used within a SharedDataProvider');
    }
    return context;
};


